import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { CONTROL_APP_CONST } from "../../config/control-app.constant";
import {
  SimpleTableConfig
} from "../../../control-core/shared/simple-table/simple-table.component";
import { moneymask } from "../../../control-core/util/moneymask.util";
import { OrdenPagoModel } from "../../models/ser/ordenpago.model";
import { initWaitMe, stopWaitMe } from "../../../control-core/util/waitme.util";
import Swal from 'sweetalert2'
import { TranslateService } from "@ngx-translate/core";
import { ErrorService } from "../../../control-core/services/error.service";
import { NGXLogger } from "ngx-logger";
import { BuscarCiudadModel } from "../buscar-ciudad/buscar-ciudad.model";
import { notify, SUCCESS_NOTIFY, WARING_NOTIFY } from "../../../control-core/util/notify.util";
import {
  IPdrConcepto, WhrRespuestaCotizacionModel,
  WhrCotizarDataModel,
  WhrProductoCotizacionModel
} from "./whr-cotizar.model";
import * as cloneDeep from 'lodash/cloneDeep';
import { DireccionesUserComponent } from "../direcciones-user/direcciones-user.component";
import { CiudadModel, DepartamentoModel, PaisModel } from "../../models/general/gestion-geografica.model";
import { ValidatorService } from "../../../control-core/services/validator-service";
import { GeparametersService } from "../../../control-core/services/geparameters.service";
import { Subscription } from "rxjs/Subscription";

@Component({
  selector: 'app-whr-cotizar',
  templateUrl: './whr-cotizar.component.html'
})
export class WhrCotizarComponent implements OnInit {

  @ViewChild(DireccionesUserComponent) direccionesUserComponent: DireccionesUserComponent;

  @Input() data: WhrCotizarDataModel;
  @Output() onSelectService: EventEmitter<WhrProductoCotizacionModel> = new EventEmitter<WhrProductoCotizacionModel>();
  @Output() onGeneratePaymentOrder: EventEmitter<{ status: boolean, message: any, service: WhrProductoCotizacionModel }>;

  serviciosTbl: SimpleTableConfig<WhrProductoCotizacionModel>;
  conceptosTblData: IPdrConcepto[];
  generandoOrdenPago: boolean = false;
  cotizando: boolean = false;
  mostrarTblCotizacion: boolean = true;
  enviandoCorreo: boolean = false;
  ciudadDestino: BuscarCiudadModel = new BuscarCiudadModel(new CiudadModel(), new DepartamentoModel(), new PaisModel());
  cotizarInput = {hasError: false, errorText: ""};
  inputErrors = [];
  dataCotizar: any = {};
  limitVlrDeclarado: number = 0;
  limitVlrAsegurado: number = 0;
  minVlrDeclarado: number = 0;
  minVlrAsegurado: number = 0;

  public VALOR_DECLARADO_LABEL = this._translate.instant('VALOR_DECLARADO_LABEL') + " (USD)";
  public VALOR_ASEGURADO_LABEL = this._translate.instant('VALOR_ASEGURADO_LABEL') + " (USD)";
  public VLRDEC_WHR_INVALID_LABEL = "";
  public VLRASE_WHR_INVALID_LABEL = "";

  private _currentService: WhrProductoCotizacionModel;
  private _resCotizacion: WhrRespuestaCotizacionModel;
  private _cotizacionTBLID = '#cotizacionTBL';
  private readonly _CONFIRMA_CREACION_ORDEN_PAGO = 'CONFIRMA_CREACION_ORDEN_PAGO_VALUEUSD_COP';
  private readonly _YES_LABEL = this._translate.instant('YES_LABEL');
  private readonly _NO_LABEL = this._translate.instant('NO_LABEL');
  private readonly _COTIZACION_ENVIADA = this._translate.instant('COTIZACION_ENVIADA');
  private _valoresObligatoriosCotizacion = ['valordeclarado', 'valorasegurado', 'peso'];
  private readonly _REVISAR_CAMPOS_DIRECCION = this._translate.instant('REVISAR_CAMPOS_DIRECCION');
  private _subGeparameters$: Subscription = null;

  constructor(private _http: HttpClient,
              private _errorService: ErrorService,
              private _logger: NGXLogger,
              private _validatorService: ValidatorService,
              private _translate: TranslateService,
              private _parameters: GeparametersService) {
    this._currentService = new WhrProductoCotizacionModel();
    this.onGeneratePaymentOrder = new EventEmitter<{ status: boolean, message: any, service: WhrProductoCotizacionModel }>();
    this.data = new WhrCotizarDataModel();

    //Inicializando el vector de errores de los input
    this._valoresObligatoriosCotizacion.forEach(value => {
      this.inputErrors[value] = {hasError: false, errorText: ''};
    });

  }

  ngOnInit() {
    this.serviciosTbl = new SimpleTableConfig<WhrProductoCotizacionModel>([
      {
        label: "SERVICIO_LABEL",
        name: "nombre"
      },
      {
        label: "TOTAL_LABEL",
        name: "total",
        options: {
          render: (data) => {
            return 'USD ' + moneymask(data);
          }
        }
      }
    ]);
    this.serviciosTbl.optionColumns = [];
    this.serviciosTbl.allowSelectRow = true;

    this._subGeparameters$ = this._parameters.state$.subscribe((estado) => {
      if (estado == 'ready') {
        this.limitVlrDeclarado = this._parameters.getNumval('CTRLBX_LIMIT_VLR_DECLARADO');
        this.minVlrDeclarado = this._parameters.getNumval('CTRLBX_MIN_VLR_DECLARADO');
        this.limitVlrAsegurado = this._parameters.getNumval('CTRLBX_LIMIT_VLR_ASEGURADO');
        this.minVlrAsegurado = this._parameters.getNumval('CTRLBX_MIN_VLR_ASEGURADO');
        this.VLRDEC_WHR_INVALID_LABEL = this._translate.instant('VLRDEC_WHR_INVALID_LABEL',
            {
              maximo_declarado: this.limitVlrDeclarado,
              minimo_declarado: this.minVlrDeclarado
            });
        this.VLRASE_WHR_INVALID_LABEL = this._translate.instant('VLRASE_WHR_INVALID_LABEL',
            {
              maximo_asegurado: this.limitVlrAsegurado,
              minimo_asegurado: this.minVlrAsegurado
            });
      }
    });
  }

  cotizar() {
    this.select(new WhrProductoCotizacionModel());
    let allOk = true;
    if (this.data.nrowhr != '') {
      if (!this.direccionesUserComponent.checkDireccion()) {
        notify(this._REVISAR_CAMPOS_DIRECCION, WARING_NOTIFY);
        allOk = false;
      }
      this.ciudadDestino.setFromCiudadModel(cloneDeep(this.data.destino.ciudad));
    }
    if (this._validatorService.isEmpty(this.ciudadDestino)
        || this._validatorService.isEmpty(this.ciudadDestino.ciudad_id)) {
      this.cotizarInput.hasError = true;
      this.cotizarInput.errorText = "SELECCIONE_CIUDAD_LABEL";
      allOk = false;
    } else {
      this.cotizarInput.hasError = false;
    }

    this._valoresObligatoriosCotizacion.forEach(value => {
      if (this.data[value] == null || this.data[value] < 1) {
        this.inputErrors[value]['hasError'] = true;
        this.inputErrors[value]['errorText'] = 'CAMPO_REQUIRED_LABEL';
        allOk = false;
      } else {
        this.inputErrors[value]['hasError'] = false;
      }
    });

    if(this.data.valordeclarado > this.limitVlrDeclarado || this.data.valordeclarado < this.minVlrDeclarado){
      this.inputErrors['valordeclarado']['hasError'] = true;
      this.inputErrors['valordeclarado']['errorText'] = this.VLRDEC_WHR_INVALID_LABEL;
      allOk = false;
    }else if(this.data.valorasegurado > this.limitVlrAsegurado || this.data.valorasegurado < this.minVlrAsegurado){
      this.inputErrors['valorasegurado']['hasError'] = true;
      this.inputErrors['valorasegurado']['errorText'] = this.VLRASE_WHR_INVALID_LABEL;
      allOk = false;
    }else{
      this.inputErrors['valordeclarado']['hasError'] = false;
      this.inputErrors['valorasegurado']['hasError'] = false;
    }

    if (allOk) {
      if (this._validatorService.isEmpty(this.data.nrowhr)) {
        this.dataCotizar = {
          cupon: this.data.cupon,
          ciudad_id: this.ciudadDestino.ciudad_id,
          gezona_id: this.ciudadDestino.ciudad.gezona_id,
          paquetes: {
            pesoCobrar: this.data.peso,
            pesoFisico: this.data.peso,
            piezas: [{
              alto: this.data.alto ? this.data.alto : 0,
              largo: this.data.largo ? this.data.largo : 0,
              ancho: this.data.ancho ? this.data.ancho : 0,
              peso: this.data.peso,
            }]
          },
          valorasegurado: this.data.valorasegurado,
          valordeclarado: this.data.valordeclarado,
          para_documentos: this.data.para_documentos,
          con_recogida: this.data.con_recogida
        };
      } else {
        this.dataCotizar = {
          cupon: this.data.cupon,
          ciudad_id: this.ciudadDestino.ciudad_id,
          gezona_id: this.ciudadDestino.ciudad.gezona_id,
          nrowhr: this.data.nrowhr
        };
      }
      this.cotizando = true;
      initWaitMe(this._cotizacionTBLID);
      this._http.post<WhrRespuestaCotizacionModel>(`${CONTROL_APP_CONST.API_URL}cotizar`, this.dataCotizar)
          .subscribe(resCotizacion => {
            this.cotizando = false;
            this._resCotizacion = resCotizacion;
            this.serviciosTbl.data = this._resCotizacion.productos;
            stopWaitMe(this._cotizacionTBLID);
            if (this._resCotizacion.productos.length == 0 && this.dataCotizar.cupon !== '') {
              let msg = 'Al parcer el cupón no puede ser usado en este paquete.<br>¿Desea intentarlo sin el cupón?';
              Swal({
                title: '',
                html: `<span class="font-15">${msg}</span>`,
                type: 'question',
                showCancelButton: true,
                confirmButtonText: this._YES_LABEL,
                cancelButtonText: this._NO_LABEL
              }).then((result) => {
                if (result.value) {
                  this.data.cupon = '';
                  this.cotizar();
                }
              });
            }
          }, resError => {
            this.cotizando = false;
            this._errorService.manejaError(resError);
            stopWaitMe(this._cotizacionTBLID)
          });
    }
  }

  enviarCorreo() {
    this.enviandoCorreo = true;
    this.dataCotizar['serproducto_id'] = this._currentService.id;
    this._http.post(`${CONTROL_APP_CONST.API_URL}cotizar`,
        {
          infoCot: this.dataCotizar,
          enviarCotizacion: true
        })
        .subscribe(resCotizacion => {
          notify(this._COTIZACION_ENVIADA, SUCCESS_NOTIFY);
          this.enviandoCorreo = false
        }, resError => {
          this._errorService.manejaError(resError);
          this.enviandoCorreo = false;
        });
  }

  /**
   * Funcion encargada de emitir el servicio seleccionado
   *
   * @param {WhrProductoCotizacionModel} servicio
   */
  select(servicio: WhrProductoCotizacionModel) {
    this.mostrarTblCotizacion = this._validatorService.isEmpty(servicio.id);
    this._currentService = servicio;
    this.conceptosTblData = servicio.conceptos;
    this.onSelectService.emit(this._currentService);
  }

  nowMoneyMask(symbol, data) {
    return symbol + ' ' + moneymask(data);
  };

  selectCiudadDestino($event) {
    this.ciudadDestino = $event;
  }

  generarOrdenPago() {
    this.generandoOrdenPago = true;
    let msgConf = this._translate.instant(this._CONFIRMA_CREACION_ORDEN_PAGO,
        {totalus: this.currentService.total}) + '</div><br><br>' +
        '<div id="swal2-content" style="display: block; text-align: left !important;">';

    msgConf += '<span class="font-15">' + this._translate.instant('TO_NEXT_PAQ_LABEL') + ' </span><br><br>';

    if (this.data.tracking) {
      msgConf += '<li>' + this._translate.instant('TRACKING_LABEL') + ': '
          + '<b>' + this.data.tracking + '</b></li>';
    }

    msgConf += '<li>' + this._translate.instant('DESTINO_LABEL') + ': '
        + '<b>' + this.data.destino.direccion + '<br>'
        + this.data.destino.ciudad.nombre + '/' + this.data.destino.ciudad.departamento.nombre + '/'
        + this.data.destino.ciudad.departamento.pais.nombre + '</b></li></ul>';

    msgConf += '<li>' + this._translate.instant('CONTENIDO_PAQUETE') + ':<br>'
        + '<b>' + this.data.paqdesc + '</b></li>';
    Swal({
      title: '',
      html: `<span class="font-15">${msgConf}</span>`,
      type: 'question',
      showCancelButton: true,
      confirmButtonText: this._YES_LABEL,
      cancelButtonText: this._NO_LABEL
    }).then((result) => {
      if (result.value) {
        let destinatario = this.data.generarDestinatario();
        this._http.post<OrdenPagoModel>(`${CONTROL_APP_CONST.API_URL}registrarOrdenPago`, {
          whr_id: this.data.whr_id,
          producto_id: this.currentService.id,
          cupon: this.data.cupon,
          destinatario: destinatario
        }).subscribe(resOk => {
              this.onGeneratePaymentOrder.emit({status: true, message: resOk, service: this._currentService});
              this.generandoOrdenPago = false
            },
            resErr => {
              this.onGeneratePaymentOrder.emit({
                status: false,
                message: resErr.error,
                service: this._currentService
              });
              this.generandoOrdenPago = false
            });
      } else {
        this.generandoOrdenPago = false;
      }
    });
  }

  get currentService(): WhrProductoCotizacionModel {
    return this._currentService;
  }

  get resCotizacion(): WhrRespuestaCotizacionModel {
    return this._resCotizacion
  }

  onBuscaCiudad = (texto) => {
    this.serviciosTbl.data.splice(0, this.serviciosTbl.data.length);
    this.select(new WhrProductoCotizacionModel());
  }

  ngOnDestroy() {
    this._subGeparameters$.unsubscribe();
  }
}


// WEBPACK FOOTER //
// ./src/app/control-app/shared/whr-cotizar/whr-cotizar.component.ts